// useBoardOptimisticFieldOverrides.js

import { useEffect } from 'react';

const useBoardOptimisticFieldOverrides = ({
    nodes,
    boardFieldDef,
    resolveFieldValue,
    setOptimisticFieldValues,
}) => {
    useEffect(() => {
        setOptimisticFieldValues((prev) => {
            const entries = Object.entries(prev || {});
            if (!entries.length) return prev;

            let changed = false;
            const next = {};

            entries.forEach(([nodeKey, overrideValue]) => {
                const liveNode = nodes.find((node) => node?.key === nodeKey);
                if (!liveNode) {
                    changed = true;
                    return;
                }

                const actualValue = boardFieldDef ? resolveFieldValue(liveNode, boardFieldDef) : null;
                const actualNormalized = actualValue == null || actualValue === '' ? null : String(actualValue);
                const overrideNormalized = overrideValue == null || overrideValue === '' ? null : String(overrideValue);

                if (actualNormalized === overrideNormalized) {
                    changed = true;
                    return;
                }

                next[nodeKey] = overrideValue;
            });

            return changed ? next : prev;
        });
    }, [boardFieldDef, nodes, resolveFieldValue, setOptimisticFieldValues]);
};

export default useBoardOptimisticFieldOverrides;